// extracted by mini-css-extract-plugin
export default {"link":"SM-z","disabled":"TM-z"};